export default __webpack_public_path__ + "static/media/pdf-logo.233ae2b6.png";